const MOBILE_PREVIEW_MARGIN = 32;
const DESKTOP_PREVIEW_MARGIN = 100;

export function resizePosterPreview() {
  const wrapper = document.querySelector(".poster-wrapper");
  const poster = wrapper?.querySelector(".map-wrapper");
  const preview = wrapper?.closest(".col");

  if (!wrapper || !poster || !preview) return;

  const frame = wrapper.querySelector(".poster-frame:not(.d-none)");
  const frameWidthFactor = frame ? 1.08 : 1;
  const frameHeightFactor = frame ? 1.06 : 1;
  const posterWidth = poster.offsetWidth * frameWidthFactor;
  const posterHeight = poster.offsetHeight * frameHeightFactor;

  if (!posterWidth || !posterHeight) return;

  const previewRect = preview.getBoundingClientRect();
  const tabBar = document.querySelector(".tab-bar");
  const tabBarHeight =
    window.matchMedia("(max-width: 991px)").matches && tabBar
      ? tabBar.getBoundingClientRect().height
      : 0;
  const isMobile = window.matchMedia("(max-width: 991px)").matches;
  const margin = isMobile ? MOBILE_PREVIEW_MARGIN : DESKTOP_PREVIEW_MARGIN;
  const availableWidth = Math.max(0, previewRect.width - margin * 2);
  const availableHeight = Math.max(
    0,
    previewRect.height - tabBarHeight - margin * 2,
  );
  const maxScale = poster.classList.contains("tegel") ? 0.6 : 0.7;
  const scale = Math.min(
    availableWidth / posterWidth,
    availableHeight / posterHeight,
    maxScale,
  );

  wrapper.style.transform = `scale(${scale})`;
}
